import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';
import { isLarge } from 'utils/breakpoints';

export function InfoWindowV2({ content, google, map, location, onClose }) {
	const infoWindowRef = useRef(null);
	const infoContentRef = useRef(null);
	const rootRef = useRef(null);

	useEffect(() => {
		if (!google || !map) return;

		const container = document.createElement('div');
		infoContentRef.current = container;
		const root = createRoot(container);
		rootRef.current = root;
		root.render(content);

		const viewportWidth = window.innerWidth;
		const isLargeView = isLarge(viewportWidth);
		const infoWindowInstance = new google.maps.InfoWindow({
			content: container,
			position: new google.maps.LatLng(
				location.latitude,
				location.longitude,
			),
			pixelOffset: new google.maps.Size(0, isLargeView ? 485 : 580),
		});

		google.maps.event.addListener(
			infoWindowInstance,
			'closeclick',
			onClose,
		);

		infoWindowRef.current = infoWindowInstance;
		infoWindowInstance.open(map);

		return () => {
			infoWindowInstance.close();
			google.maps.event.clearInstanceListeners(infoWindowInstance);
			infoWindowRef.current = null;
			if (rootRef.current) {
				rootRef.current.unmount();
				rootRef.current = null;
			}
		};
	}, [google, map]); // eslint-disable-line react-hooks/exhaustive-deps

	return null;
}

InfoWindowV2.propTypes = {
	content: PropTypes.node,
	google: PropTypes.shape({
		maps: PropTypes.shape({
			InfoWindow: PropTypes.func,
			LatLng: PropTypes.func,
			Size: PropTypes.func,
			event: PropTypes.shape({
				addListener: PropTypes.func,
				clearInstanceListeners: PropTypes.func,
			}),
		}),
	}),
	map: PropTypes.object,
	location: PropTypes.shape({
		latitude: PropTypes.number,
		longitude: PropTypes.number,
	}),
	onClose: PropTypes.func,
};

export default InfoWindowV2;
